<template>
  <ul v-if="renderLinks" class="footer-service-nav">
    <li v-html="languageSwitcherLink" />
    <li>
      <a onclick="window.CookieConsent.renew()" v-html="model.CookieInformationLink.Text" />
    </li>
    <li>
      <a :href="model.PersonalInformationLink.Url" v-html="model.PersonalInformationLink.Text" />
    </li>
  </ul>
</template>

<script>
import Utility from '@/common/UtilityFunctions.js';

export default {
  name: 'FooterServiceNavigation',
  props: {
    model: {
      type: Object,
      default() {
        return {
          DanishLanguageVersionLink: {},
          EnglishLanguageVersionLink: {},
          CookieInformationLink: {},
          PersonalInformationLink: {}
        };
      }
    }
  },
  computed: {
    renderLinks() {
      return (
        this.model.DanishLanguageVersionLink !== null &&
        this.model.EnglishLanguageVersionLink !== null &&
        this.model.CookieInformationLink !== null &&
        this.model.PersonalInformationLink !== null
      );
    },
    languageSwitcherLink() {
      if (Utility.getLanguageIdentifier() === 'da') {
        return (
          this.model.DanishLanguageVersionLink.Text +
          ' / <a href="' +
          this.model.EnglishLanguageVersionLink.Url +
          '" class="lang-select">' +
          this.model.EnglishLanguageVersionLink.Text +
          '</a>'
        );
      }

      return (
        '<a href="' +
        this.model.DanishLanguageVersionLink.Url +
        '" class="lang-select">' +
        this.model.DanishLanguageVersionLink.Text +
        '</a> / ' +
        this.model.EnglishLanguageVersionLink.Text
      );
    }
  }
};
</script>
